// Central image registry for AR / American Rag.
// All AI-generated brand imagery lives here so it can be swapped in one place.
const B = "https://static.prod-images.emergentagent.com/jobs/0d3e6dd2-07e2-4da7-868d-a25312b0b847/images/";
const img = (h) => `${B}${h}.jpeg`;

export const HERO = {
  home: img("510652e31bce0f180b5ab3c08931cafdfa732dd6001a099c01dc36f12b848048"),
};

export const BANNERS = {
  womenDenim: img("613e580230c94ebfc7d6e7d94ab6076ab1f150a56db8f9d3ab557e31a98b5f1e"),
  menDenim: img("1cff487db2b1190eac8d326038c36bb1bce7c1352275966b6ccf5d5c2118fc4e"),
  womenTees: img("4f8f8a4b5196874054b07156088295c668a920b695f27986338783b3d0d4a9e1"),
  menTees: img("3a98ad66eebd2cc244ea59588d3c79177871236b1936bb087a1ac8565ff3b35b"),
  womenFleece: img("6e71f95f274d560f24b180dab48f8886ab56d8a3ec30e4720a3c8e9685cdbc26"),
  menFleece: img("50f7c954ce3760c8db14a1ae2daddfe9e073ea0a85dd87238c65603951063b55"),
  newOriginals: img("510652e31bce0f180b5ab3c08931cafdfa732dd6001a099c01dc36f12b848048"),
  about: img("613e580230c94ebfc7d6e7d94ab6076ab1f150a56db8f9d3ab557e31a98b5f1e"),
  wholesale: img("4f8f8a4b5196874054b07156088295c668a920b695f27986338783b3d0d4a9e1"),
};

// Individual product shots (ghost-mannequin / studio)
export const P = {
  // men's tees
  mtEmbLogo: img("4036a8a9f38cb245418b9848077f64f5dacc5a932e991d183e5e03f049dc0a9b"),
  mtFlock: img("b26503669a1a5efb49fc392423418de4e36fe0aac19aeec3b0d0744e3274427b"),
  mtPuff: img("b277292ec86b9479a2d69e6ddadf370ea7d034220eb078f887b591fe9c584d5f"),
  mtFoil: img("4e7d0d9dcb529e70768e60336be4f5982dac8dfd78458903578b3aecb3853937"),
  // men's fleece
  mhEmb: img("c88508bb897215ca1002d4856dce3baa3a8412b35747691ebae21d1b1489e350"),
  mhPuff: img("00e556516573b9b6773828072ddca73a82c8945c767fac32b9d2fc7f0e7cf58a"),
  mhApplique: img("7ffc436a201098726612ca179c4cf811fc22fe8abb12c3bc3552b433dcd12cea"),
  // women's tees
  wtGlitter: img("17b426c64c3ef7a362b2c207f76fe4d72710d322ad558e1f0affa0d469aef735"),
  wtPuff: img("0935d12c833c64b5b7ed1e09d4922fd61ed575107b2d2319d4825346652fe8f4"),
  wtRhinestone: img("d021b31f6c75067215acc19cad839b0fdc26290684d1385c7a6bbb387e5c649d"),
  // women's fleece
  whRhinestone: img("0377054315589719a2db475b86697c1b876d6385a01f781b38882fddc20b5474"),
  whSequin: img("24e955c8ab075a0248b770c1edaac463fbeffee62bcd99ee1a142c6de2da090c"),
  whGlitter: img("1667ed40b740c0651abe1b0590cc823c4a851c48b5565085a414b684d3020595"),
  // denim portraits
  denWomen: img("d91e9d2ec3cbc012523be8408b22f58dac9f343bf2b5f88a47acbb2e475623be"),
  denMen: img("0caa6d62283c7c0dd6a404dccc2fbe13d338a76324e01391f29397e5d3e418a3"),
};

// Denim — per-style accurate model shots (generated from the official references)
// plus the original reference crop from the PDF for comparison / fallback.
export const HOME_HERO = img("3df60406ed8d68cbd46fd79165ee42092f6c16c7abfe35dd307134d55486056c");

export const DENIM = {
  arw0008st: { model: img("3a99b3fa3a33de5c907a7e401f2bf71e492a526d96c156f7ed31b429a5cf155b"), ref: "/refs/arw0008st_ref.jpg" },
  arw000bt: { model: img("286a423b24e8683c60a9093acebd35ea48fb5e10ffefd923579be3230472c770"), ref: "/refs/arw000bt_ref.jpg" },
  ar0008msl: { model: img("18c958cc8479fafa3751b562ac192b2e1646b646dc11c9f891e279fd3101deda"), ref: "/refs/ar0008msl_ref.jpg" },
  ar0008mst: { model: img("9c0ac10abdd58d1b17e6027887f40d9b5f490b2826533659d66abf03cb5c8b35"), ref: "/refs/ar0008mst_ref.jpg" },
};

// Per-category image pools. Products cycle through these.
export const POOL = {
  menTee: [P.mtFlock, P.mtPuff, P.mtFoil, P.mtEmbLogo],
  menHoodie: [P.mhEmb, P.mhPuff, P.mhApplique],
  womenTee: [P.wtGlitter, P.wtPuff, P.wtRhinestone],
  womenHoodie: [P.whRhinestone, P.whGlitter, P.whSequin],
  womenDenim: [P.denWomen],
  menDenim: [P.denMen],
};

export const pick = (pool, i) => pool[i % pool.length];
